import React, { useContext, useEffect, useState } from "react";
import classes from "./Header.module.css";
import { ReactComponent as IconCart } from "../../assets/cart.svg";
import { ReactComponent as IconSun } from "../../assets/sun.svg";
import { ReactComponent as IconMoon } from "../../assets/moon.svg";
import { CartContext } from "../../context/CartContext";
import { ColorModeContext } from "../../context/ColorModeContext";
import SearchField from "./SearchField";
import useDeviceType from '../../customHook/useDeviceType';

const fetchConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar o config:", error);
    return null;
  }
};
const config = await fetchConfig();

const fetchStrings = async () => {
  try {
    const response = await fetch(`${config.url}/catalogo/${config.diretorio}/mensagens.json?v=${crypto.randomUUID()}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar os produtos:", error);
    return [];
  }
};
const strings = await fetchStrings();

const Header = ({ onShow }) => {
  const isMobile = useDeviceType();
  const { itemsCart } = useContext(CartContext);
  const { changeMode, isDarkMode } = useContext(ColorModeContext);
  const [pageScrolled, setPageScrolled] = useState(false);

  const totalItemsInTheCart = itemsCart.items.reduce((prev, curr) => {
    return prev + curr.amount;
  }, 0);

  useEffect(() => {
    const scrollPage = () => {
      if (window.scrollY > 16) {
        setPageScrolled(true);
      } else {
        setPageScrolled(false);
      }
    };

    window.addEventListener("scroll", scrollPage);

    return () => {
      window.removeEventListener("scroll", scrollPage);
    };
  }, []);

  const openWhatsapp = () => {
    window.open(`https://${isMobile ? 'api' : 'web'}.whatsapp.com/send?phone=5548991676165&text=${strings.whatsappmessage}`)
  }

  const openWebsitePersonalia = () => {
    window.location.assign(`https://personalia.com.br`)
  }

  return (
    <header
      className={`${classes.header} ${pageScrolled ? classes.scroll : ""}`}
    >
      <div className={`container ${classes.container}`}>
        
        <span className={classes.logo} onClick={openWebsitePersonalia}>
          <div className={classes.logoimage}>
            <svg viewBox="0, 0, 400,401.4925373134328"><path d="M177.000 29.077 C 143.612 31.300,115.073 39.803,87.400 55.775 C 69.862 65.897,40.986 87.679,38.582 92.600 C 36.699 96.455,39.085 109.104,46.846 136.400 C 50.340 148.689,54.188 150.084,72.598 145.738 C 82.171 143.479,85.808 144.103,87.990 148.380 C 89.059 150.475,89.858 155.005,94.380 184.600 C 95.254 190.320,96.871 200.850,97.972 208.000 C 102.539 237.635,104.129 247.995,105.828 259.200 C 106.813 265.690,107.878 272.530,108.196 274.400 C 108.514 276.270,109.865 285.090,111.197 294.000 C 112.530 302.910,114.346 314.700,115.232 320.200 C 116.118 325.700,117.558 334.880,118.431 340.600 C 121.823 362.826,122.677 365.652,126.920 368.700 C 133.884 373.701,154.818 374.676,163.218 370.391 C 168.852 367.517,169.861 365.112,173.008 347.073 C 174.013 341.313,175.276 334.170,175.814 331.200 C 176.352 328.230,177.336 322.430,178.001 318.310 C 181.976 293.668,182.473 293.039,197.200 294.020 C 209.488 294.839,232.368 292.260,249.200 288.160 C 349.171 263.804,394.689 178.557,345.887 107.086 C 311.299 56.430,242.623 24.709,177.000 29.077 M232.397 149.408 C 248.339 151.685,268.743 162.400,272.951 170.704 C 280.035 184.683,270.952 201.335,247.000 218.283 C 228.002 231.725,200.215 241.800,195.249 237.046 C 192.723 234.628,192.782 232.862,196.000 214.600 C 196.853 209.760,198.736 198.870,200.184 190.400 C 207.825 145.714,206.587 148.177,221.200 148.604 C 225.050 148.717,230.089 149.078,232.397 149.408" stroke="none" fill="#FFFFFF" fill-rule="evenodd"/></svg>
          </div>
          <span className={classes.logoname}>Personalia</span>
        </span>

        <SearchField />

        <button className={classes.customMug} onClick={openWhatsapp}>
          <svg fill="#FFFFFF" width="22px" height="22px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.42 9.49c-.19-.09-1.1-.54-1.27-.61s-.29-.09-.42.1-.48.6-.59.73-.21.14-.4 0a5.13 5.13 0 0 1-1.49-.92 5.25 5.25 0 0 1-1-1.29c-.11-.18 0-.28.08-.38s.18-.21.28-.32a1.39 1.39 0 0 0 .18-.31.38.38 0 0 0 0-.33c0-.09-.42-1-.58-1.37s-.3-.32-.41-.32h-.4a.72.72 0 0 0-.5.23 2.1 2.1 0 0 0-.65 1.55A3.59 3.59 0 0 0 5 8.2 8.32 8.32 0 0 0 8.19 11c.44.19.78.3 1.05.39a2.53 2.53 0 0 0 1.17.07 1.93 1.93 0 0 0 1.26-.88 1.67 1.67 0 0 0 .11-.88c-.05-.07-.17-.12-.36-.21z"/><path d="M13.29 2.68A7.36 7.36 0 0 0 8 .5a7.44 7.44 0 0 0-6.41 11.15l-1 3.85 3.94-1a7.4 7.4 0 0 0 3.55.9H8a7.44 7.44 0 0 0 5.29-12.72zM8 14.12a6.12 6.12 0 0 1-3.15-.87l-.22-.13-2.34.61.62-2.28-.14-.23a6.18 6.18 0 0 1 9.6-7.65 6.12 6.12 0 0 1 1.81 4.37A6.19 6.19 0 0 1 8 14.12z"/></svg>

          <span>{strings.whatsappbutton}</span>
        </button>

        {/* <button className={classes.cart} onClick={onShow}>
          <span className={classes.cartTxt}>Seu carrinho</span>
          <span className={classes.amount}>
            <IconCart />
            <span className={classes.value}>{totalItemsInTheCart}</span>
          </span>
        </button> */}

        <button
          className={classes.btnColorMode}
          onClick={changeMode}
          title={isDarkMode ? "Ativar modo claro" : "Ativar modo escuro"}
        >
          {isDarkMode ? <IconSun /> : <IconMoon />}
        </button>
      </div>
    </header>
  );
};

export default Header;
